// Types
import type { MasterType } from "../../types"

export const defaultMasterData: MasterType = {
  customer: []
}